import Add from './add.svg';
import AddToDashboard from './add-to-dashboard.svg';
import AddFill from './add-fill.svg';
import AddFilter from './add-filter.svg';
import Alerts from './alerts.svg';
import AlertsNotification from './alerts-notification.svg';
import Archive from './archive.svg';
import AlertsAdd from './alerts-add.svg';
import Android from './android.svg';
import ArrowDiagonal from './arrow-diagonal.svg';
import ArrowDown from './arrow-down.svg';
import ArrowLeft from './arrow-left.svg';
import ArrowRight from './arrow-right.svg';
import ArrowUp from './arrow-up.svg';
import AutoplayActive from './autoplay-active.svg';
import AutoplayInactive from './autoplay-inactive.svg';
import BulkAdd from './bulk-add.svg';
import CaretDown from './caret-down.svg';
import CaretUp from './caret-up.svg';
import CheckmarkFill from './checkmark-fill.svg';
import Checkmark from './checkmark.svg';
import ChevronDown from './chevron-down.svg';
import ChevronLeft from './chevron-left.svg';
import ChevronRight from './chevron-right.svg';
import ChevronUp from './chevron-up.svg';
import Clock from './clock.svg';
import Close from './close.svg';
import Console from './console.svg';
import Copy from './copy.svg';
import Delete from './delete.svg';
import DeviceDesktop from './device-desktop.svg';
import DeviceLaptop from './device-laptop.svg';
import DeviceMobile from './device-mobile.svg';
import DeviceTablet from './device-tablet.svg';
import DeviceRobot from './device-robot.svg';
import DeviceServer from './device-server.svg';
import DeviceUnknown from './device-unknown.svg';
import Disable from './disable.svg';
import Download from './download.svg';
import Duplicate from './duplicate.svg';
import Edit from './edit.svg';
import Enable from './enable.svg';
import ErrorWarning from './error-warning.svg';
import ErrorWarningFill from './error-warning-fill.svg';
import EventUnion from './event-union.svg';
import FolderCheckmark from './folder-checkmark.svg';
import Grid from './grid.svg';
import Hamburger from './hamburger.svg';
import Help from './help.svg';
import HelpFill from './help-fill.svg';
import Indeterminate from './indeterminate.svg';
import InformationMinimal from './information-minimal.svg';
import InformationPrimary from './information-primary.svg';
import InformationSecondary from './information-secondary.svg';
import iOS from './ios.svg';
import LegendDot from './legend-dot.svg';
import LegendDotStroke from './legend-dot-stroke.svg';
import Link from './link.svg';
import List from './list.svg';
import Logout from './logout.svg';
import Menu from './menu.svg';
import Metrics from './metrics.svg';
import MoreHoriz from './more-horiz.svg';
import MoreVert from './more-vert.svg';
import Move from './move.svg';
import Network from './network.svg';
import NotAllowed from './not-allowed.svg';
import Note from './note.svg';
import Notifications from './notifications.svg';
import ObjectChanges from './object-changes.svg';
import PageInsights from './page-insights.svg';
import Privacy from './privacy.svg';
import Recording from './recording.svg';
import Refresh from './refresh.svg';
import Search from './search.svg';
import Segments from './segments.svg';
import Sort from './sort.svg';
import Star from './star.svg';
import StarOutline from './star-outline.svg';
import TextArea from './text-area.svg';
import Undo from './undo.svg';
import ViewDetail from './view-detail.svg';

export default {
  add: Add,
  'add-fill': AddFill,
  'add-filter': AddFilter,
  'add-to-dashboard': AddToDashboard,
  alerts: Alerts,
  'alerts-notification': AlertsNotification,
  'alerts-add': AlertsAdd,
  archive: Archive,
  'arrow-diagonal': ArrowDiagonal,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'autoplay-active': AutoplayActive,
  'autoplay-inactive': AutoplayInactive,
  'bulk-add': BulkAdd,
  'caret-down': CaretDown,
  'caret-up': CaretUp,
  checkmark: Checkmark,
  'checkmark-fill': CheckmarkFill,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clock: Clock,
  close: Close,
  console: Console,
  copy: Copy,
  delete: Delete,
  'device-desktop': DeviceDesktop,
  'device-laptop': DeviceLaptop,
  'device-mobile': DeviceMobile,
  'device-tablet': DeviceTablet,
  'device-robot': DeviceRobot,
  'device-server': DeviceServer,
  'device-unknown': DeviceUnknown,
  disable: Disable,
  download: Download,
  duplicate: Duplicate,
  edit: Edit,
  enable: Enable,
  'error-warning': ErrorWarning,
  'error-warning-fill': ErrorWarningFill,
  'event-union': EventUnion,
  'folder-checkmark': FolderCheckmark,
  grid: Grid,
  hamburger: Hamburger,
  help: Help,
  'help-fill': HelpFill,
  indeterminate: Indeterminate,
  'information-minimal': InformationMinimal,
  'information-primary': InformationPrimary,
  'information-secondary': InformationSecondary,
  'legend-dot': LegendDot,
  'legend-dot-stroke': LegendDotStroke,
  link: Link,
  list: List,
  logout: Logout,
  menu: Menu,
  metrics: Metrics,
  'more-horiz': MoreHoriz,
  'more-vert': MoreVert,
  move: Move,
  network: Network,
  'not-allowed': NotAllowed,
  note: Note,
  notifications: Notifications,
  'object-changes': ObjectChanges,
  'page-insights': PageInsights,
  'platform-android': Android,
  'platform-ios': iOS,
  privacy: Privacy,
  recording: Recording,
  refresh: Refresh,
  search: Search,
  segments: Segments,
  sort: Sort,
  star: Star,
  'star-outline': StarOutline,
  'text-area': TextArea,
  undo: Undo,
  'view-detail': ViewDetail,
};
